export default __webpack_public_path__ + "static/media/checkout.1c113368.svg";